import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';

import { BRAND_CONFIG } from '@shared/services';

@Component({
  selector: 'app-linx-footer',
  templateUrl: './linx-footer.component.html',
  styleUrls: ['./linx-footer.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinxFooterComponent {
  @Input() businessName!: string;

  readonly brand = inject(BRAND_CONFIG);
}
